import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0 
 *
 **/
const ModalCancelProductAction = {
    /**
     * 获取单个出库详情
     * @param data
     */
    post(data={},sUrl) {
        return request({
            url: sUrl,
            method: "POST",
            data
        });
    },
};

export default ModalCancelProductAction;
